// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDVKdKB4ywFpJbgk0eitXVwG7YeSjwGCa4",
    authDomain: "chareety-dev-4.firebaseapp.com",
    projectId: "chareety-dev-4",
    storageBucket: "chareety-dev-4.firebasestorage.app",
    messagingSenderId: "768587471920",
    appId: "1:768587471920:web:03720638a3e014749fa1f5",
    measurementId: "G-2EQGWZV5ZN"
  },
  // App Check debug token (auto-registered by Ops/register-app.js — do not edit)
  appCheckDebugToken: "9aa3650f-5c0e-429c-8c2c-972a14d0b6bd",
  // reCAPTCHA Enterprise site key (dev)
  recaptchaSiteKey: "6LcCeYktAAAAAMZKXfGG07RZJMpqyW08BlPuVwLl",
  appDomain: "dev.chareety.com",
  appUrls: {
    onboard: "https://onboard-dev.chareety.com",
    partners: "https://partners-dev.chareety.com",
    myChareety: "https://my-dev.chareety.com",
    orgConsole: "https://console-dev.chareety.com",
    marketing: "https://dev.chareety.com",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
